class MHeader extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };
    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };
    this.init();
  }

  init() {
    this.updateChromeMeasurements();
    this.observeChromeMeasurements();
    this.transparentHeader =
      this.domNodes && this.domNodes.headers[0] && this.domNodes.headers[0].dataset.transparent === "true";
    this.initAddon();
    this.handleSticky();
    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());
    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;
    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
    });
  }

  updateChromeMeasurements() {
    const activeHeader = this.querySelector(window.innerWidth < 1024 ? '.m-header__mobile' : '.m-header__desktop');
    const topbar = this.domNodes.topbar;
    const announcement = document.querySelector('m-announcement-bar');
    const dimensions = {
      header: activeHeader ? activeHeader.offsetHeight : 0,
      topbar: topbar ? topbar.offsetHeight : 0,
      announcement: announcement ? announcement.offsetHeight : 0,
      wrapper: this.domNodes.headerWrapper.offsetHeight,
    };

    this.headerHeight = dimensions.wrapper;
    window.MinimogSettings.headerHeight = dimensions.header;
    window.MinimogSettings.topbarHeight = dimensions.topbar;
    window.MinimogSettings.announcementHeight = dimensions.announcement;

    const root = document.documentElement.style;
    for (const name of ['header', 'topbar', 'announcement']) {
      const property = `--m-${name}-height`;
      const value = `${dimensions[name]}px`;
      if (root.getPropertyValue(property) !== value) root.setProperty(property, value);
    }
  }

  observeChromeMeasurements() {
    this.scheduleChromeMeasurements = () => {
      if (this.chromeMeasurementFrame) return;
      this.chromeMeasurementFrame = requestAnimationFrame(() => {
        this.chromeMeasurementFrame = null;
        if (this.isConnected) this.updateChromeMeasurements();
      });
    };

    if ('ResizeObserver' in window) {
      this.chromeResizeObserver = new ResizeObserver(this.scheduleChromeMeasurements);
      const elements = [...this.domNodes.headers, this.domNodes.topbar, document.querySelector('m-announcement-bar')];
      elements.filter(Boolean).forEach(element => this.chromeResizeObserver.observe(element));
    }
    window.addEventListener('resize', this.scheduleChromeMeasurements, { passive: true });
  }

  disconnectedCallback() {
    this.chromeResizeObserver?.disconnect();
    window.removeEventListener('resize', this.scheduleChromeMeasurements);
    if (this.chromeMeasurementFrame) cancelAnimationFrame(this.chromeMeasurementFrame);
  }

  initAddon() {
    this.megamenu = new Megamenu(this);
    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme && MinimogTheme.Wishlist && MinimogTheme.Wishlist.updateWishlistCount();
    }
  }
  handleSticky() {
    let extraSpace = 20;
    const sectionGroups = document.querySelectorAll(".shopify-section-group-header-group");
    sectionGroups.forEach((section) => {
      if (!section.classList.contains("m-section-header") && !section.classList.contains("m-section-scaling-logo")) {
        extraSpace += section.offsetHeight;
      }
    });
    const topBar = document.querySelector(".m-topbar");
    if (topBar) extraSpace += topBar.offsetHeight;

    let lastScroll = 0;
    window.addEventListener("scroll", () => {
      const currentScroll = window.scrollY;
      if (currentScroll <= extraSpace) {
        this.classList.remove(this.classes.scrollUp, this.classes.stuck, this.classes.always);
        document.body.classList.remove(this.classes.headerScrollUp, this.classes.headerScrollDown);
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);
        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (currentScroll < lastScroll && this.classList.contains(this.classes.scrollDown)) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);
        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }
      lastScroll = currentScroll;
    });
  }
}
customElements.define("m-header", MHeader);
